import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { subscriptionDifference } from 'utils/subscriptionUtils';
import { getActionParam } from 'utils/commonUtils';

import { openLightbox } from 'modules/Common/reducers/display';
import { deleteSubscriptions, saveSubscriptions } from 'modules/Common/reducers/userService';

import { NOT_LOGGED_IN_ERROR } from 'modules/Common/consts';

require('./SubscriptionContainer.scss');

@connect(state => ({
  subscriptions: state.common.userService.subscriptions,
  auth: state.common.auth
}))
export default class SubscriptionContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    subscriptions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    addSubscriptions: PropTypes.array.isRequired,
    icon: PropTypes.node.isRequired
  };

  loggedIn = () => {
    const {
      auth: {
        loggedIn = false
      } = {}
    } = this.props;

    return loggedIn;
  }

  componentDidMount() {
    const [reqType, reqId] = getActionParam("subscribe");

    if (reqId) {
      const {
        addSubscriptions = []
      } = this.props;

      // get a list of those subscriptions this container is responsible for, that match the URL subscription parameter, and that aren't already subscribed to (ie don't have a valid subId)
      // There will be only one, since the URL param can't container several, at the moment
      const subsToAdd = addSubscriptions.filter(({type, id, subId}) => (!subId && (type == reqType) && (id == reqId)));

      if (subsToAdd.length) {
        this.saveSubscriptions(subsToAdd);
      }
    }
  }

  saveSubscriptions = (subscriptionsToSave) => {
    const {
      dispatch,
      addSubscriptions: [{ // when there are more than one, they're all the same type
        type
      }]
    } = this.props;


    if (!this.loggedIn()) {
      dispatch(openLightbox('login', type));
      return Promise.reject(NOT_LOGGED_IN_ERROR);
    } else {
      return this.dispatchSubscription(true, saveSubscriptions, subscriptionsToSave);
    }
  }

  deleteSubscriptions = () => this.dispatchSubscription(false, deleteSubscriptions);

  dispatchSubscription = (filter, dispatchFunc, subscriptionsToUpdate = this.filterSubscriptions(filter)) => {
    const {
      dispatch,
      auth
    } = this.props;

    if (subscriptionsToUpdate.length > 0) {
      return dispatch(dispatchFunc(auth, subscriptionsToUpdate));
    }
    return Promise.reject();
  }

  hasSubscriptions = () => {
    return this.filterSubscriptions(false).length > 0;
  }

  filterSubscriptions = difference => {
    const {
      subscriptions = {},
      addSubscriptions = []
    } = this.props;

    return subscriptionDifference(addSubscriptions, subscriptions, difference);
  }

  render() {
    const {
      icon
    } = this.props;

    if (!icon) {
      return null;
    }

    return React.cloneElement(icon, {
      hasSubscriptions: this.hasSubscriptions(),
      saveSubscriptions: this.saveSubscriptions,
      deleteSubscriptions: this.deleteSubscriptions
    });
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Subscriptions/SubscriptionContainer.js